import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../header/headerDashboard';
import { deleteRequest, startRent } from '../../actions/beds';
import { DeleteFilled, CheckCircleFilled, EnvironmentOutlined, ClockCircleOutlined, CommentOutlined, MedicineBoxOutlined } from "@ant-design/icons";

const Waiting = (props) => {
    const [request, setRequest] = useState([]);
    const [bedNumbers, setBedNumbers] = useState({});
    const [mattresses, setMattresses] = useState({});

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/request/`, {
            method: 'GET',
            credential: true,
            headers: new Headers({
                'Content-Type': 'application/json',
            })
        })
            .then(async (res) => {
                if (res.status === 200) return res.json();
                throw await res.json();
            })
            .then((res) => {
                setRequest(res);
            }).catch((err) => {
                console.log(err);
            });
    }, []);

    const handleBedNumberChange = (id, value) => {
        setBedNumbers(prev => ({ ...prev, [id]: value }));
    };

    const handleMattressChange = (id, value) => {
        setMattresses(prev => ({ ...prev, [id]: value }));
    };

    const deleteRequestAction = (id) => {
        deleteRequest(id);
        setRequest(request.filter(element => element._id !== id));
    };

    const startRentRequestAction = (element) => {
        const eleId = element._id;
        startRent(bedNumbers[eleId], element, !!mattresses[eleId]);
        deleteRequest(eleId);
        setRequest(request.filter(el => el._id !== eleId));
    };

    return (
        <div>
            <HeaderDashboard />
            <div style={{ padding: '24px 16px', maxWidth: 900, margin: '0 auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                    <h2 style={{ margin: 0, fontWeight: 700, fontSize: 22, color: '#1a1a2e' }}>
                        Demandes en cours
                    </h2>
                    <span style={{
                        backgroundColor: '#1a1a2e',
                        color: '#fff',
                        borderRadius: 20,
                        padding: '2px 12px',
                        fontSize: 13,
                        fontWeight: 600,
                    }}>
                        {request.length}
                    </span>
                </div>

                {request.length === 0 && (
                    <div style={{
                        textAlign: 'center',
                        padding: '48px 24px',
                        color: '#aaa',
                        backgroundColor: '#fafafa',
                        borderRadius: 12,
                        border: '1px dashed #e0e0e0',
                    }}>
                        <div style={{ fontSize: 36, marginBottom: 12 }}>📋</div>
                        <div style={{ fontSize: 15 }}>Aucune demande en cours</div>
                    </div>
                )}

                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                    {request.map((element) => (
                        <div
                            key={element._id}
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: 12,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                                border: '1px solid #f0f0f0',
                                borderLeft: '4px solid #1a1a2e',
                                overflow: 'hidden',
                            }}
                        >
                            {/* Header de la carte */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '14px 18px 10px',
                                borderBottom: '1px solid #f5f5f5',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <span style={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: '50%',
                                        backgroundColor: '#1a1a2e',
                                        color: '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 700,
                                        fontSize: 15,
                                        flexShrink: 0,
                                    }}>
                                        {element.client ? element.client.charAt(0).toUpperCase() : '?'}
                                    </span>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a2e' }}>
                                            {element.client || <span style={{ color: '#bbb', fontStyle: 'italic' }}>Client inconnu</span>}
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#888', marginTop: 1 }}>
                                            <MedicineBoxOutlined />
                                            <span>{element.pharmacy}</span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#888' }}>
                                    <ClockCircleOutlined />
                                    <span>{new Date(element.date).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                                </div>
                            </div>

                            {/* Infos */}
                            <div style={{ padding: '10px 18px', display: 'flex', flexDirection: 'column', gap: 6 }}>
                                {element.address && (
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#555' }}>
                                        <EnvironmentOutlined style={{ marginTop: 2, color: '#888' }} />
                                        <a
                                            href={"https://maps.google.com/?q=" + element.address}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ color: '#1a73e8', textDecoration: 'none' }}
                                        >
                                            {element.address}
                                        </a>
                                    </div>
                                )}
                                {element.comment && (
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#555' }}>
                                        <CommentOutlined style={{ marginTop: 2, color: '#888' }} />
                                        <span style={{ fontStyle: 'italic' }}>{element.comment}</span>
                                    </div>
                                )}
                            </div>

                            {/* Actions */}
                            <div style={{
                                padding: '10px 18px 14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                flexWrap: 'wrap',
                            }}>
                                <input
                                    type="number"
                                    placeholder="N° de lit"
                                    value={bedNumbers[element._id] || ''}
                                    onChange={(e) => handleBedNumberChange(element._id, e.target.value)}
                                    style={{
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 8,
                                        padding: '6px 10px',
                                        fontSize: 13,
                                        width: 110,
                                        outline: 'none',
                                    }}
                                />
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    fontSize: 13,
                                    color: '#555',
                                    cursor: 'pointer',
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={!!mattresses[element._id]}
                                        onChange={(e) => handleMattressChange(element._id, e.target.checked)}
                                    />
                                    Matelas fourni
                                </label>
                                <button
                                    onClick={() => startRentRequestAction(element)}
                                    disabled={!bedNumbers[element._id]}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        backgroundColor: bedNumbers[element._id] ? '#27ae60' : '#e0e0e0',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: 8,
                                        padding: '6px 14px',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: bedNumbers[element._id] ? 'pointer' : 'not-allowed',
                                        transition: 'background-color 0.2s',
                                    }}
                                >
                                    <CheckCircleFilled />
                                    Attribuer
                                </button>
                                <button
                                    onClick={() => deleteRequestAction(element._id)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        backgroundColor: 'transparent',
                                        color: '#c0392b',
                                        border: '1px solid #c0392b',
                                        borderRadius: 8,
                                        padding: '6px 14px',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                    }}
                                >
                                    <DeleteFilled />
                                    Supprimer
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Waiting;
